<section class="public-marketplace-page" [class.rtl]="languageService.currentLanguage() === 'ar'">
  <header class="public-topbar">
    <a class="public-brand" routerLink="/">
      <img src="assets/images/loadgate-new-logo.png" alt="LoadGate" />
      <span>LOADGATE</span>
    </a>

    <div class="public-topbar-actions">
      <a
        class="button whatsapp-button"
        href="https://api.whatsapp.com/send/?phone=966535301814&text&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Open WhatsApp AI chat"
      >
        <span class="whatsapp-icon" aria-hidden="true">
          <svg viewBox="0 0 32 32" focusable="false">
            <path
              fill="currentColor"
              d="M19.11 17.41c-.29-.15-1.7-.84-1.97-.94-.26-.1-.45-.15-.64.15-.19.29-.73.94-.9 1.13-.17.19-.34.22-.63.08-.29-.15-1.23-.45-2.34-1.43-.86-.77-1.45-1.72-1.62-2.01-.17-.29-.02-.45.13-.59.13-.13.29-.34.43-.5.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.08-.15-.64-1.55-.88-2.13-.23-.55-.47-.48-.64-.49l-.55-.01c-.19 0-.5.07-.76.36-.26.29-1 1-1 2.43 0 1.43 1.03 2.81 1.18 3 .15.19 2.02 3.09 4.89 4.34.68.29 1.2.47 1.61.61.68.21 1.29.18 1.77.11.54-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.34Z"
            />
            <path
              fill="currentColor"
              d="M16 3.2c-7.05 0-12.8 5.69-12.8 12.68 0 2.23.59 4.42 1.71 6.35L3 28.8l6.75-1.77a12.9 12.9 0 0 0 6.25 1.59c7.05 0 12.8-5.69 12.8-12.69C28.8 8.89 23.05 3.2 16 3.2Zm0 23.26c-2.02 0-3.99-.54-5.71-1.56l-.41-.24-4 .99 1.07-3.9-.26-.4a10.38 10.38 0 0 1-1.61-5.42c0-5.72 4.71-10.37 10.5-10.37 5.79 0 10.5 4.65 10.5 10.37 0 5.72-4.71 10.53-10.5 10.53Z"
            />
          </svg>
        </span>
        <span>{{ text('WhatsApp AI', 'واتساب الذكاء الاصطناعي') }}</span>
      </a>
      <a class="button ghost ai-agent-button" routerLink="/public/ai-broker">
        <i class="pi pi-microchip-ai"></i>
        <span>{{ text('AI agent', 'وكيل الذكاء') }}</span>
      </a>
      @if (pwaInstall.canInstallPwa() && !pwaInstall.isPwaInstalled()) {
      <button type="button" class="button install-app-button" (click)="installApp()">
        <i class="pi pi-download"></i>
        <span>{{ text('Install App', 'تثبيت التطبيق') }}</span>
      </button>
      }
      <div class="language-switcher" aria-label="Language">
        <button
          type="button"
          [class.active]="languageService.currentLanguage() === 'en'"
          (click)="setLanguage('en')"
        >
          EN
        </button>
        <button
          type="button"
          [class.active]="languageService.currentLanguage() === 'ar'"
          (click)="setLanguage('ar')"
        >
          عربي
        </button>
      </div>
      <button type="button" class="button ghost" (click)="login()">
        <i class="pi pi-sign-in"></i>
        <span>{{ text('Login', 'دخول') }}</span>
      </button>
      <button type="button" class="button primary" (click)="login()">
        <i class="pi pi-plus"></i>
        <span>{{ text('Post load/availability', 'إضافة شحنة أو توفر') }}</span>
      </button>
    </div>
  </header>

  <div class="marketplace-intro">
    <div>
      <p class="eyebrow">{{ text('Public marketplace', 'السوق العام') }}</p>
      <h1>
        {{
          text(
            'Live loads, truck availability, and trusted companies',
            'الشحنات وتوفر الشاحنات والشركات الموثوقة'
          )
        }}
      </h1>
      <p class="intro-copy">
        {{
          text(
            'Browse public loads, carrier availability, and company directory records with trust signals. Sign in when you are ready to contact, post, or send an offer.',
            'تصفح الشحنات العامة وتوفر الناقلين وسجلات دليل الشركات مع مؤشرات الثقة. سجل الدخول عندما تريد التواصل أو الإضافة أو إرسال عرض.'
          )
        }}
      </p>
    </div>

    <div class="intro-actions">
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'loads'"
        (click)="selectTab('loads')"
      >
        <i class="pi pi-box"></i>
        <span>{{ text('Loads', 'الشحنات') }}</span>
      </button>
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'availability'"
        (click)="selectTab('availability')"
      >
        <i class="pi pi-truck"></i>
        <span>{{ text('Availability', 'التوفر') }}</span>
      </button>
      <a class="tab-button" routerLink="/public/directory">
        <i class="pi pi-building"></i>
        <span>{{ text('Company Directory', 'دليل الشركات') }}</span>
      </a>
    </div>
  </div>

  @if (activeTab === 'loads') {
    <app-public-loads-list></app-public-loads-list>
  } @else {
    <app-public-availabilities-list></app-public-availabilities-list>
  }
</section>
